'use client';

import { ReactNode } from 'react';

import Link from 'next/link';

import FacebookIcon from '@/app/components/FacebookIcon/FacebookIcon';
import InstagramIcon from '@/app/components/InstagramIcon/InstagramIcon';
import LinkedInIcon from '@/app/components/LinkedInIcon/LinkedInIcon';
import PodcastIcon from '@/app/components/PodcastIcon/PodcastIcon';
import XIcon from '@/app/components/XIcon/XIcon';
import YoutubeIcon from '@/app/components/YoutubeIcon/YoutubeIcon';
import { countryConfig, SocialMenuItemm } from '@/app/utils/countryConfig';

export const menuItemsIcon: Record<SocialMenuItemm, ReactNode> = {
  [SocialMenuItemm.FACEBOOK]: <FacebookIcon />,
  [SocialMenuItemm.X]: <XIcon />,
  [SocialMenuItemm.INSTAGRAM]: <InstagramIcon />,
  [SocialMenuItemm.YOUTUBE]: <YoutubeIcon className="max-w-full" />,
  [SocialMenuItemm.LINKEDIN]: <LinkedInIcon />,
  [SocialMenuItemm.PODCAST]: <PodcastIcon />,
};

const SocialNavigation = () => {
  return (
    <nav>
      <ul className="flex gap-[16px]">
        {countryConfig.socialNavigationItems.map(({ id, link }) => (
          <li key={id}>
            <Link
              href={link}
              prefetch={process.env.NEXT_PUBLIC_PREFETCH_LINKS === 'true'}
              className="flex justify-center items-center w-[40px] h-[40px] rounded-full bg-primary-light text-primary-mid hover:bg-white transition-all border-2 border-primary-light"
            >
              {menuItemsIcon[id]}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SocialNavigation;
